export enum DraggablePageEvents {
  ON_PAGE_CLICKED = 'on-page-click',
  ON_PAGE_REORDERED = 'on-page-reordered',
}
